import { getScheduledRecordingAssets, KuxProgramType, PresentationAdditionalTypeEnum } from '@kaltura-ott/tvpil';
import { lastValueFrom } from 'rxjs';

import { CardPlaceholder, Program } from '../../../../entities';
import { addBookmarkToRecords, creatorEntityStore } from '../../../../entities/entities.service';
import { getItemsInPage, DEFAULT_PAGE_SIZE } from '../../../widgets/rails/rail-store-helper-v2';
import { RailStoreV2 } from '../../../widgets/rails/rail-store-v2';

/**
 * Record additional rail store for future singles and series recordings
 * @category Store
 */
export class RecordAdditionalRailStoreV2 extends RailStoreV2<Program> {
  subtype: PresentationAdditionalTypeEnum.record_additional_rail =
    PresentationAdditionalTypeEnum.record_additional_rail;

  private seriesId = '';
  public seriesTypeScheduledRecordingsRailTitle =
    this.parentCategoryTree?.railProperty.seriesTypeScheduledRecordingsRailTitle;

  async setupSeriesId(seriesId?: string) {
    if (seriesId) {
      this.seriesId = seriesId;
    }
    await this.init();
  }

  async getData(
    pageIndex: number,
    items: (Program | CardPlaceholder)[],
  ): Promise<{ items: (Program | CardPlaceholder)[]; totalCount: number; newItems: Program[] }> {
    const newRailData = await lastValueFrom(getScheduledRecordingAssets(pageIndex, DEFAULT_PAGE_SIZE, this.seriesId));

    const newItems: Program[] = newRailData.items.map((item: KuxProgramType) => creatorEntityStore(item));

    this.items.push(...newItems);

    return { items: this.items, totalCount: newRailData.totalCount, newItems };
  }

  protected async getAdditionData(programsInPage: Program[]): Promise<void> {
    await addBookmarkToRecords(programsInPage);
    return undefined;
  }

  protected async restoreAdditionData(pageIndex: number, items: Program[]): Promise<void> {
    return this.getAdditionData(getItemsInPage(items, pageIndex));
  }
}
